import "./axios"
import "./vue";
import "./polyfills/scrollIntoViewIfNeeded";
import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init();
